<template lang="pug">
.home
  Intro.intro
  .overlay(:class="$mq")
    Goals.goals
    Features.features
    Team.team
    Footer.footer
</template>

<script>
import Intro from './Intro'
import Goals from './Goals'
import Features from './Features'
import Team from './Team'
import Footer from './Footer'

export default {
  name: 'Home',
  components: {
    Intro,
    Goals,
    Features,
    Team,
    Footer
  }
}
</script>

<style lang="scss">
h1,
h2,
h3,
h4,
h5 {
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}
</style>

<style lang="scss" scoped>
@use '@/styles/colors';

.home {
  width: 100%;
  min-height: 100vh;
}

.intro {
  min-height: 100vh;
  background-image: linear-gradient(
    100deg,
    colors.$intense-purple,
    colors.$light-purple-gradient
  );
  padding-bottom: 200px;
}

@mixin border-radius($pixels) {
  border-top-left-radius: $pixels;
  border-top-right-radius: $pixels;
}

.overlay {
  display: grid;
  grid-auto-rows: auto;
  margin-top: -200px;
  width: 100%;
  background-color: white;

  &.phone,
  &.tablet-portrait {
    @include border-radius(40px);
  }

  &.tablet-landscape {
    @include border-radius(50px);
  }

  &.desktop,
  &.large-desktop {
    @include border-radius(70px);
  }
}
</style>
